module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_2_3.b5ef6fc9.png";